// src/components/Integrations/InstagramOAuthCallback.jsx
"use client";

import { useEffect, useState } from 'react';
import Spinner from '../Spinner';
import MetaService from '../../services/meta.service';

const InstagramOAuthCallback = () => {
  const [status, setStatus] = useState('processing');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const run = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const oauthError = urlParams.get('error');
      const oauthErrorDesc = urlParams.get('error_description');

      if (oauthError) {
        const msg = oauthErrorDesc || oauthError;
        setStatus('error');
        setErrorMessage(msg);
        window.opener?.postMessage(
          { type: 'OAUTH_ERROR', platform: 'instagram', error: msg },
          window.location.origin
        );
        setTimeout(() => window.close(), 2000);
        return;
      }

      if (!code || !state) {
        const msg = 'Missing code or state in callback URL';
        setStatus('error');
        setErrorMessage(msg);
        window.opener?.postMessage(
          { type: 'OAUTH_ERROR', platform: 'instagram', error: msg },
          window.location.origin
        );
        setTimeout(() => window.close(), 2000);
        return;
      }

      const result = await MetaService.processInstagramCallback({ code, state });

      if (result.success) {
        setStatus('success');
        window.opener?.postMessage(
          { type: 'OAUTH_SUCCESS', platform: 'instagram', data: result.data },
          window.location.origin
        );
        setTimeout(() => window.close(), 1200);
      } else {
        const msg = result.error?.message || 'Instagram connection failed';
        setStatus('error');
        setErrorMessage(msg);
        window.opener?.postMessage(
          { type: 'OAUTH_ERROR', platform: 'instagram', error: msg },
          window.location.origin
        );
        setTimeout(() => window.close(), 2500);
      }
    };

    run();
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg text-center max-w-md">
        {status === 'processing' && (
          <>
            <div className="flex justify-center mb-4">
              <Spinner size="xl" color="pink" />
            </div>
            <h2 className="text-white text-lg font-medium mb-2">Connecting Instagram…</h2>
            <p className="text-gray-400 text-sm">
              Finishing authorization with Meta. This window will close automatically.
            </p>
          </>
        )}
        {status === 'success' && (
          <>
            <h2 className="text-white text-lg font-medium mb-2">Instagram connected</h2>
            <div className="bg-pink-900/20 border border-pink-700 rounded-lg p-3">
              <p className="text-pink-200 text-sm">
                You can close this window.
              </p>
            </div>
          </>
        )}
        {status === 'error' && (
          <>
            <h2 className="text-white text-lg font-medium mb-2">Connection failed</h2>
            <div className="bg-red-900/20 border border-red-700 rounded-lg p-3">
              <p className="text-red-200 text-sm break-words">{errorMessage}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InstagramOAuthCallback;
